import { configureStore } from "@reduxjs/toolkit"

/* Reducers */
import operators from "./operators"
import admin from "./admin"
import loading from "./loading"
import language from "./language"
import timezone from "./timezone"



/* Actions */
import { actionOperator, getAdminVariables } from "./actions"

const store = configureStore({
    reducer: {
        operators,
        admin,
        loading,
        language,
        timezone,
    },
})

actionOperator(store)
getAdminVariables(store)

export { store }